var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !!_vm.value
        ? _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px", persistent: "" },
              on: {
                input: function ($event) {
                  return _vm.$emit("input", $event)
                },
              },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.operation) + " Certificate"),
                  ]),
                  _c("v-card-text", { staticClass: "pb-1" }, [
                    _c("div", { staticClass: "text-container" }, [
                      _c("span", { staticClass: "title-text" }, [
                        _vm._v("Are you sure you want to "),
                        _c("b", [_vm._v(_vm._s(_vm.operation.toUpperCase()))]),
                        _vm._v(" the certificate for "),
                        _c("b", [_vm._v(_vm._s(_vm.machine.MachineName))]),
                        _vm._v("?"),
                      ]),
                    ]),
                    _vm.operation == "Recreate"
                      ? _c("div", { staticClass: "text-container" }, [
                          _c("span", { staticClass: "title-text" }, [
                            _vm._v(
                              "This action will remove the current certificate and can not be undone."
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "v-form",
                    { staticClass: "ml-3 mr-3" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          rules: [() => !!_vm.confirmationText || "Required"],
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("span", [_vm._v(_vm._s(_vm.message))]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2583351366
                        ),
                        model: {
                          value: _vm.confirmationText,
                          callback: function ($$v) {
                            _vm.confirmationText = $$v
                          },
                          expression: "confirmationText",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "text-container",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c("v-icon", { attrs: { size: "30", color: "red" } }, [
                        _vm._v("mdi-alert"),
                      ]),
                      _c("span", { staticClass: "subtitle-text" }, [
                        _vm._v(
                          "Updating the machine with a new certificate is required for data transmission."
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("input", false)
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            disabled:
                              _vm.confirmationText !=
                              _vm.operation.toLowerCase(),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.createCertificate()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.operation))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-overlay",
        { attrs: { opacity: 0.5, value: _vm.loading, "z-index": "300" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "42" },
          }),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "primary", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackBar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackBar,
            callback: function ($$v) {
              _vm.snackBar = $$v
            },
            expression: "snackBar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackBarText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }